import {ActionRowButtonProps} from "peggirkit";

export const buttonStyling: Partial<ActionRowButtonProps> = {
    borderRadius: "rounded-full",
    iconOnly: true,
    breakpoints: {md: {iconOnly: false, borderRadius: undefined}},
};